module.exports = __webpack_public_path__ + "static/media/envelope-send.50940415.svg";